import Container from "@/components/ui/Container";
import SectionLabel from "@/components/ui/SectionLabel";
import GradientHeading from "@/components/ui/GradientHeading";
import Card from "@/components/ui/Card";
import AlertIcon from "@/assets/mib/alert.svg?react";
import NestedArrowsIcon from "@/assets/mib/nested-arrows.svg?react";
import HelpIcon from "@/assets/mib/help.svg?react";

const Arrow = () => <span className="text-coral">→</span>;

const cards = [
  {
    Icon: AlertIcon,
    title: "Ложные срабатывания",
    body: (
      <>
        Сканеры выдают тысячи уязвимостей <Arrow /> непонятно, что чинить
      </>
    ),
  },
  {
    Icon: NestedArrowsIcon,
    title: "Долгое согласование релизов",
    body: <>Каждый релиз согласовывается с ИБ больше недели</>,
  },
  {
    Icon: HelpIcon,
    title: "Нет контекста для разработчика",
    body: (
      <>
        Разработчик получает CVE и уровень риска <Arrow /> но разбираться
        приходится вручную
      </>
    ),
  },
];

export default function ProblemSection() {
  return (
    <section>
      <Container>
        <div className="xl:grid xl:grid-cols-4 xl:gap-5">
          <SectionLabel>Проблема</SectionLabel>
          <div className="mt-3 xl:col-span-3 xl:mt-0">
            <GradientHeading>
              {"Сканер нашёл 3\u00A0000 CVE "}
              <br className="hidden md:inline" />
              {"— ни одного приоритета"}
            </GradientHeading>
          </div>
        </div>

        <div className="mt-5 grid grid-cols-1 gap-2.5 min-[478px]:mt-[30px] min-[478px]:gap-5 md:mt-[60px] md:grid-cols-2 xl:mt-[90px] xl:grid-cols-4">
          <p className="mb-[30px] text-[16px] font-medium leading-[1.3] text-ink min-[478px]:mb-10 md:mb-0 md:mt-[25px] md:max-w-[246px]">
            Классические инструменты не показывают, запускается ли уязвимый код
            и доступен ли он из сети
          </p>

          {cards.map(({ Icon, title, body }) => (
            <Card key={title} className="md:min-h-[250px] xl:min-h-[265px]">
              <div className="flex size-[44px] items-center justify-center rounded-[5px] bg-navy text-coral">
                <Icon className="size-5" />
              </div>
              <h3 className="mt-[23px] font-bold leading-none text-navy text-[21px] tracking-[-0.21px]">
                {title}
              </h3>
              <p className="mt-6 text-[16px] font-medium leading-[1.3] text-ink">
                {body}
              </p>
            </Card>
          ))}
        </div>
      </Container>
    </section>
  );
}
